/**
 * Перевод даты из moment-js в js Date без затирания браузером смещения таймзоны
 * @param {moment.Moment} m
 * @return {Date}
 */
export const momentToDate = (m) => new Date(m.format("YYYY-MM-DDTHH:mm:ss"));
